//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

/**
 * This file contains shared models to ensure that social text parsing method share a consistent
 * API, ensuring consistency when we need to switch between them for components that are used
 * for multiple networks.
 */

/**
 * This enum represents every possible parseable "entity" within social text,
 * even if the specific social network in question doesn't recognize this entity.
 */
export const SocialTextEntityType = {
  Cashtag: 'Cashtag',
  FacebookPageMention: 'FacebookPageMention',
  Hashtag: 'Hashtag',
  InstagramMention: 'InstagramMention',
  Mention: 'Mention',
  Text: 'Text',
  Url: 'Url',
} as const;
export type SocialTextEntityType =
  (typeof SocialTextEntityType)[keyof typeof SocialTextEntityType];

export interface ISocialTextEntity<
  T extends SocialTextEntityType = SocialTextEntityType,
> {
  type: T;
  value: string;
  start?: number;
  end?: number;
}

export type SocialTextParseMethod<
  T extends SocialTextEntityType = SocialTextEntityType,
> = (text: string) => ISocialTextEntity<T>[];
